// @flow
import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../../assets/css/colors';
import geniusSportsLogo from "../../assets/images/genius.png";
import Facebook from '../../components/Icons/Facebook';
import Twitter from '../../components/Icons/Twitter';
import Instagram from '../../components/Icons/Instagram';
import { below } from '../../assets/css/media.js';

const FooterStyled = styled.footer`
	background: ${colors.footer_background};
	color: #ffffff;
	padding: 0 2.375em;

	${below.desktop`
		padding: 0 1em;
	`}

	a {
		color: #fff;
		text-decoration: none;
	}
`;
const FooterTop = styled.div`
	padding: 1.375em 0;
	display: flex;
	align-items: center;
	border-bottom: 1px solid ${colors.nrlDarkGreenHover};
	${below.desktop`
		justify-content: space-between;
	`}
	.title {
		line-height: 1.777778;
		font-weight: bold;
	}
`;
const SocialWrapper = styled.div`
	margin-left: 2.75em;
	display: flex;
	align-items: center;
	font-size: 18px;
`;
const FooterMenu = styled.div`
	padding: 1.25em 0;
	display: flex;
	align-items: center;

	${below.desktop`
		flex-direction: column;
	`}
	ul {
		display: flex;
		flex: 80%;

		li {
			margin: 0 1em;
			&:first-child {
				margin-left: 0;
			}
		}
		a {
			font-size: 12px;
			span {
				color: ${colors.lightGreen};
			}
			&:hover {
				color: ${colors.nrlGreen};
			}
		}
	}
`;

const FanHubLogoWrapper = styled.a`
	display: flex;
	align-items: center;
	font-weight: bold;
	font-size: 12px;

	${below.desktop`
		margin-top: 3em;
		flex-direction: column;
	`}
	svg {
		margin-left: 17px;

		${below.desktop`
			margin-top: .1em;
		`}
	}
`;

const SocialLinkStyled = styled.a`
	align-items: center;
	border: 1px solid ${({ border_color })=> border_color ? border_color : colors.nrlDarkGreen};
	cursor: pointer;
	display: flex;
	height: 36px;
	justify-content: center;
	width: 36px;
	transition: all 0.2s;
	border-radius: 2px;

	&:not(:last-child) {
		margin-right: 0.3125rem;
	}
	&:hover {
		border-color: ${colors.nrlGreen};
	}

	svg {
		pointer-events: none;
    }
`;

const FooterImg = styled.img`
	width: 80px;
`;


export const Footer = () => (
	<FooterStyled>
		<FooterTop className="top-footer">
			<div className="title">FOLLOW NRL FANTASY</div>
			<SocialWrapper className="social">
				<SocialLinkStyled href="https://www.facebook.com/nrlfantasy/" target="_blank"
				   rel="noopener noreferrer" aria-label="Follow on Facebook">
					<Facebook size="1.5"/>
				</SocialLinkStyled>
				<SocialLinkStyled href="https://twitter.com/nrlfantasy" target="_blank"
				   rel="noopener noreferrer" aria-label="Follow on Twitter">
					<Twitter size="1.5"/>
				</SocialLinkStyled>
				<SocialLinkStyled href="https://www.instagram.com/nrlfantasy/" target="_blank"
				   rel="noopener noreferrer" aria-label="Follow on Instagram">
					<Instagram size="1.5"/>
				</SocialLinkStyled>
			</SocialWrapper>
		</FooterTop>
		<FooterMenu className="footer-menu">
			<ul>
				<li>
					<NavLink to="/help/terms-and-conditions" target="_blank">
						<span>
							Terms & Conditions
						</span>
					</NavLink>
				</li>
				<li>
					<NavLink to="/help/faq" target="_blank">
						<span>
							FAQ
						</span>
					</NavLink>
				</li>
				<li>
					<NavLink to="/help/rules" target="_blank">
						<span>
							Rules
						</span>
					</NavLink>
				</li>
				<li>
					<NavLink to="/help/guidelines" target="_blank">
						<span>
							Game Guidelines
						</span>
					</NavLink>
				</li>
			</ul>
			<FanHubLogoWrapper href="http://fanhubmedia.com/" target="_blank"
			                   rel="noopener noreferrer">
				<FooterImg src={geniusSportsLogo} alt="Genius Sports"></FooterImg>
			</FanHubLogoWrapper>
		</FooterMenu>
	</FooterStyled>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.js